<template>
  <div class="products-search-bar">
    <!-- BUSQUEDA POR CODIGO -->
    <div v-if="!typeah" class="products-search-bar__code">
      <div class="input-group">
        <div class="input-group-prepend">
          <button type="button" class="btn btn-primary" title="Buscar por nombre" @click="toggleTypeah">
            <i class="bi bi-search"></i>
          </button>
        </div>
        <input
          type="text"
          class="form-control"
          ref="searchCodeBox"
          v-model="code"
          placeholder="Ingresa cod. de producto. Podes ingresar una cantidad. Por Ej. 3*1002"
          autocomplete="off"
          @keyup="lookupProducts">
      </div>
      <barcode-scanner-button class="products-search-bar__scanner" @scan="addProductByCode" />
    </div>

    <!-- BUSQUEDA POR NOMBRE -->
    <div v-if="typeah" class="products-search-bar__name">
      <button v-if="showBarcodes" type="button" class="btn btn-primary products-search-bar__toggle" title="Buscar por codigo" @click="toggleTypeah">
        <i class="bi bi-upc-scan"></i>
      </button>
      <div class="products-search-bar__typeahead">
        <typeaheadp
          :name="'product'"
          :placeh="'Buscar producto por nombre...'"
          :custom-class="'nameBox'"
          :clean-on="true"
          v-on:choosed="productChoosed"
          :default="product_default"
          :externalsrc="'/api/products/getProducts'"
          limit-chars="3"
          ref="searchNameBox"/>
      </div>
    </div>
  </div>
</template>

<script>
import typeaheadp from '../global/TypeaheadProd.vue';
import BarcodeScannerButton from '@/components/shared/BarcodeScannerButton.vue';

export default {
  props: ['separator', 'showBarcodes', 'product_default', 'priceList'],
  data: function() {

    return {
      code: '',
      id_code: null,
      typeah: false
    }
  },
  mounted () {
      this.typeah = !this.showBarcodes;
      this.$refs.searchCodeBox.focus();
  },
  methods: {
    productChoosed(data){
      this.togglet();
      this.id_code = data.id;
      this.addProduct();
    },
    lookupProducts: function(e) {
      var app = this;
      if (this.typeah) return;
      if (this.showBarcodes && e.key === 'Enter' ) {
        app.addProductByCode();
      }
    },
    addProductByCode: function(rawCode){
      var app = this;
      // Lectura por teclado/USB no pasa argumento (usa app.code); el scanner de camara
      // emite el codigo crudo (sin cantidad ni separador) como argumento.
      var source = (typeof rawCode === 'string' && rawCode.length) ? rawCode : app.code;
      var code = source.split(app.separator);
      var qu=(code.length !== 1) ? parseInt(code[0]) : 1;
      var co=(code.length !== 1) ? code[1] : code;

      if (co!=null) {
      window.axios.get('/api/products/getProductByCode/'+co+'/'+this.priceList).then(function(response) {
        if (response.data.code === 422) {
          alert(response.data.message + ' o se encuentra INACTIVO!');
        }else {
          response.data.data.quantity = qu;
          response.data.data.discount = 0;
          app.code='';
          app.$emit('productadded',response.data.data);
        }
      });
      }
    },
    addProduct: function(){
      var app = this;

      if (app.id_code!=null && app.id_code>0) {
        window.axios.get('/api/products/getProduct/'+app.id_code+'/'+app.priceList).then(function(response) {
          response.data.data.quantity = 1;
          response.data.data.discount = 0;
          app.$emit('productadded',response.data.data);
        });
      app.id_code = null;
      }
    },
    togglet: function(){
      if (this.showBarcodes) this.toggleTypeah();
    },
    toggleTypeah() {
      this.typeah=!this.typeah;
      if (this.typeah)
        this.$nextTick(() => this.$refs.searchNameBox.$refs.nameBox.focus())
      else
        this.$nextTick(() => this.$refs.searchCodeBox.focus())
    }
  },
  components: {
    typeaheadp,
    BarcodeScannerButton
  },
}
</script>
